module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/ko_1-757c5b1de0b4a15f390c0ecc1b1d7a82.jpg";